import type { ClientGroupJoinRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineGroupEventsApi } from '@/features/api/hooks/grapevine-group-events/useGrapevineGroupEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useJoinGroup = () => {
  const api = useGrapevineGroupEventsApi();
  const queryClient = useQueryClient();

  return useApiMutation({
    mutationFn: (clientGroupJoinRequest: ClientGroupJoinRequest) =>
      api.joinGroup({ clientGroupJoinRequest }),
    successMessageKey: 'joinGroup.success',
    onSuccess: (data) => {
      queryClient.setQueriesData(
        { queryKey: [API_CACHE_KEYS.GROUP, data.group.id] },
        () => data.group
      );
      queryClient.invalidateQueries({ queryKey: [API_CACHE_KEYS.GROUPS] });
    }
  });
};
